import queryString from "query-string";
export default (restServer) => ({
    GET_TRADERS: (deskGroupId) => restServer(queryString.stringifyUrl({
        url: "/internal/api/security/userprincipals/traders",
        query: {
            deskGroupId,
        },
    })),
    GET_TRADERS_PATH: (deskGroupId) => queryString.stringifyUrl({
        url: "/internal/api/security/userprincipals/traders",
        query: {
            deskGroupId,
        },
    }),
    GET_ALL_TRADERS_PATH: () => "/internal/api/security/userprincipals/traders",
    GET_ALL_TRADERS: () => restServer("/internal/api/security/userprincipals/traders"),
    GET_PORTFOLIO_MANAGERS_PATH: () => "/internal/api/security/userprincipals/portfoliomanagers",
    GET_TRADING_DESKS_PATH: () => "/internal/api/security/groupprincipals/desks",
});
